// extracted by mini-css-extract-plugin
export var fadeIn = "_i5-1";
export var modalContent = "_i5-3";
export var overlay = "_i5-0";
export var popoverContent = "_i5-2";
export var results = "_i5-5";
export var searchInputWrapper = "_i5-4";